const locale = {
  placeholder: 'Zaman seç',
  rangePlaceholder: ['Başlangıç zamanı', 'Bitiş zamanı']
};
export default locale;